import moment from 'moment';
import {
  filteredData,
  isAllColumnsSelected ,
  selectedPreset,
  currentPresetColumnsList
} from './fines.selectors';

const columns = [
  {
    name: 'panel',
    label: 'Панель',
    width: 75,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'fine_type',
    label: 'Тип',
    width: 75,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'sender',
    label: 'От',
    width: 75,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'recipient',
    label: 'Кому',
    width: 75,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'fine_time',
    label: 'Дата',
    width: 100,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'fine_id',
    label: 'ID',
    width: 75,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'total',
    label: 'Сумма',
    width: 75,
    sectionId: 'section_1',
    isSelected: true,
    aggregation_type: 'sum'
  }
];

export const finesInitialState = {
  fines: {
    data: [],
    ui: {
      favorites: []
    },
    meta: {
      isLoading: false,
      hasError: false,
      loaded: false,
      in_process: null,
      onPage: 0,
      page: 1,
      pageSize: 50,
      pages: 0
    },
    filters: {
      startDate: moment().startOf('month').hours(1),
      endDate: moment().endOf('month').hours(1),
      grouping: {
        selected: null,
        options: []
      },
      status: {
        selected: null,
        options: []
      },
      columnSettings: {
        currentPresetId: 0,
        availablePresets: [
          {
            id: 0,
            label: 'по умолчанию',
            columnsConfiguration: columns
          }
        ],
        lastSelectedPresetColumns: []
      },
      isDecimal: false,
      search: ''
    },
    selectors: {
      filteredData,
      isAllColumnsSelected,
      selectedPreset,
      currentPresetColumnsList
    }
  }
};
